<template>
  <td class="align-middle text-center" :class="getProcessingStatusColorClass(status)">
    <span v-if="status">
      {{ splitCamelCase(status) }} <span v-if="by">({{ by === 'ai' ? by.toUpperCase() : splitCamelCase(by) }})</span>
    </span>
  </td>
</template>

<script>
import { useReport } from '@/use/report'
import { useHelper } from '@/use/helper'

export default {
  props: {
    status: {
      default: ''
    },
    by: {
      default: ''
    }
  },
  setup() {
    const { getProcessingStatusColorClass } = useReport()
    const { splitCamelCase } = useHelper()
    return {
      getProcessingStatusColorClass,
      splitCamelCase
    }
  }
}
</script>
